import { render, staticRenderFns } from "./CardFiltrosBusca.vue?vue&type=template&id=2be660f4&scoped=true"
import script from "./CardFiltrosBusca.vue?vue&type=script&lang=js"
export * from "./CardFiltrosBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be660f4",
  null
  
)

export default component.exports